<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：个人中心</div>
    </div>
    <div class="list-content">
      <div class="pass">
        <div class="title">
          <div class="name">密码修改</div>
        </div>
        <div class="box">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="旧密码" prop="oldPass">
              <el-input type="password" v-model="ruleForm.oldPass"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="pass" required>
              <el-input
                type="password"
                v-model="ruleForm.pass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPass" required>
              <el-input
                type="password"
                v-model="ruleForm.checkPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <span class="btn3" @click="submitForm('ruleForm')">确认修改</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="info">
        <div class="title">
          <div class="name">个人信息</div>
        </div>
        <div class="box">
          <el-form
            :model="infoForm"
            status-icon
            :rules="rules"
            ref="infoForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="昵称" prop="name">
              <el-input v-model="infoForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="infoForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <div class="flex align-center justify-start">
                <el-input v-model="infoForm.code"></el-input>
                <span class="codeTex" v-show="show" @click="getPhoneCode()">获取验证码</span>
                <span class="codeTex gray" v-show="!show">{{ count }}s</span>
              </div>
            </el-form-item>

            <el-form-item>
              <span class="btn3" @click="submitForm('infoForm')">确认修改</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  updateOrganDetail,
  getOrganDetail,
  updatePasswordOrg,
} from "@/api/index";
import rules from "@/utils/rules";
import {getPhoneCode} from "@/api/login";
export default {
  name: "pass",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      id: "",
      show: true, // 60秒倒计时
      count: "",
      timer: null,
      ruleForm: {
        pass: "",
        checkPass: "",
        oldPass: "",
      },
      infoForm: {
        name: "",
        phone: "",
        code: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        phone: [
          { required: true, message: "请输入", trigger: "blur" },
          rules.phone
        ],
        code: [{ required: true, message: "请输入", trigger: "blur" }],
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        oldPass: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.shzzuser;
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 3,
    });
    this.getUserInfo()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "ruleForm") {
            this.setpass();
          }
          if (formName == "infoForm") {
            this.setInfo();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取手机号验证码
    async getPhoneCode(){
      this.$refs.infoForm.validateField('phone', async (valid) => {
        if (!valid && this.show) {
          const loading = this.$loading({
            lock: true,
            text: '正在发送...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let _data = await getPhoneCode(this.infoForm.phone);
          loading.close();
          if(_data.code == 200) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }else {
            this.$message.error(_data.message)
          }
        }
      })
    },

    // 修改个人信息
    async setInfo() {
      let _res = await updateOrganDetail(
        this.infoForm.name,
        this.infoForm.phone,
        this.infoForm.code,
      );
      if (_res.code === 200) {
        this.$message.success(_res.message);
        this.getUserInfo();
      } else {
        this.$message.error(_res.message);
      }
    },

    async getUserInfo() {
      let _data = await getOrganDetail();
      if (_data.code === 200) {
        this.infoForm.name = _data.data.organ_name
        this.infoForm.phone = _data.data.phone
        this.$store.state.shzzuser = _data.data;
        await window.localStorage.setItem(
          "shzzuser",
          JSON.stringify(_data.data)
        );
      }
    },

    // 修改密码
    async setpass() {
      let _res = await updatePasswordOrg(
        this.ruleForm.oldPass,
        this.ruleForm.checkPass
      );
      if (_res.code === 200) {
        this.$message.success(_res.message);
        this.$store.dispatch("LogOut").then(() => {
          this.$router.replace("/orglogin");
        });
      } else {
        this.$message.error(_res.message);
      }
    },
  },
  watch: {},
  filters: {},
};
</script>
<style scoped lang="scss">
.main {
  width: 100%;

  .codeTex {
    width: 140px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    color: #064fb5;
    &.gray {
      color:  #b2b2b2;
    }
  }

  .curse-content {
    width: 100%;
    padding: 20px 0;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    //background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .pass {
      width: 40%;
      margin-right: 5%;
      box-shadow: #f2f3f4 0px 0px 10px;
    }
    .info {
      width: 40%;
      margin-left: 5%;
      box-shadow: #f2f3f4 0px 0px 10px;
    }

    .title {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .name {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
      }
    }
    .box {
      width: 100%;
      margin: 0 auto;
      min-height: 400px;
      border-radius: 10px;
      padding: 20px;
      background-color: #ffffff;
      padding-top: 50px;
      .btn3 {
        display: block;
        width: 150px;
        height: 40px;
        background-color: #3381c3;
        border-radius: 20px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        margin: 0 auto;
        margin-left: calc(50% - 120px);
      }
    }
  }
}
</style>
